module.exports = __webpack_public_path__ + "img/partnership-create-account.4aef44f.png";